import { useEffect } from "react";
import { Outlet, useParams, Navigate } from "react-router-dom";
import { authClient } from "@/lib/auth-client";
import { getCurrentOrgId, setCurrentOrgId } from "@/lib/org-context";
import { Loader2 } from "lucide-react";

export function OrgLayout() {
  const { orgId } = useParams<{ orgId: string; slug: string }>();
  const { data: orgs, isPending: orgsPending } = authClient.useListOrganizations();

  const matchedOrg = orgs?.find((org) => org.id === orgId);
  const fallbackOrg = !matchedOrg && orgs?.length ? orgs[0] : null;

  // Set org context synchronously so child components have orgId on first render
  if (matchedOrg && getCurrentOrgId() !== matchedOrg.id) {
    setCurrentOrgId(matchedOrg.id);
  }

  // Clear org context on unmount
  useEffect(() => {
    return () => setCurrentOrgId(null);
  }, []);

  if (orgsPending) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!orgs?.length) {
    return <Navigate to="/onboarding/create-org" replace />;
  }

  if (!matchedOrg && fallbackOrg) {
    return <Navigate to={`/${fallbackOrg.id}/${fallbackOrg.slug}/dashboard`} replace />;
  }

  return <Outlet />;
}
